// Static fallback data — used when Supabase is not configured
const analyses = [
  {
    id: 1,
    number: "001",
    source: "Fox News",
    source_color: "#003366",
    category: "Politics",
    headline: '"Exposed: The $3 Billion Communist Network Behind the \'No Kings\' Protests"',
    date: "March 28, 2026",
    read_time: "4 min read",
    fact_tags: [
      "9M+ protesters",
      "CPUSA: ~15,000 members",
      "0.004% of US population",
      "3,300+ events in 50 states",
      "Owner: Murdoch family",
    ],
    decoded:
      "Fox frames 9 million protesters as puppets of a \"$3B communist network.\" The Communist Party USA has roughly 15,000 members \u2014 that's 0.004% of the US population. More Americans get hospitalized by lightning strikes every year.\n\nThe goal isn't to prove the claim. The goal is to discredit the messenger so you don't hear the message. If you can paint 9 million people as communist puppets, you don't have to address why they're marching.\n\nAP and Reuters reported this as the largest protest movement since the George Floyd demonstrations. Fox chose to lead with a funding conspiracy. That tells you everything.",
    pull_quote:
      "More Americans get hospitalized by lightning strikes every year than are members of CPUSA.",
    ap_comparison:
      "AP reported: \"9 million Americans march in third round of No Kings protests across all 50 states.\" Fox reported: \"Exposed: The $3 Billion Communist Network Behind the 'No Kings' Protests.\" Same event. Different reality.",
    upvotes: 342,
    downvotes: 18,
    comments: 47,
  },
  {
    id: 2,
    number: "002",
    source: "Fox News",
    source_color: "#003366",
    category: "Politics",
    headline:
      '"Trump\'s Epic 80th Birthday Bash: UFC Champions, World Leaders Unite for White House Cage Fight Spectacle"',
    date: "March 28, 2026",
    read_time: "3 min read",
    fact_tags: [
      "Day 29 of Iran war",
      "1,900+ killed",
      "13 US soldiers dead",
      "$60M event cost",
      "Owner: Murdoch family",
    ],
    decoded:
      "On Day 29 of Operation Epic Fury \u2014 with 1,900+ people dead in Iran, 13 US soldiers killed, and the Strait of Hormuz functionally closed \u2014 Fox News leads with an upbeat preview of Trump's $60M UFC cage fight at the White House for his 80th birthday.\n\nYou don't need to lie. You just need to choose which truth to put on top.\n\nThis is agenda-setting in its purest form. Fox isn't hiding the war. It's on their website, buried under entertainment. But the editorial choice of what goes on the front page \u2014 what millions see first \u2014 that IS the manipulation. The war is page 4. The party is page 1.",
    pull_quote:
      "You don't need to lie. You just need to choose which truth to put on top.",
    ap_comparison:
      'AP led with: "Iran rejects 15-point US peace plan as Houthi forces enter conflict." Fox led with: "Trump\'s Epic 80th Birthday Bash." On the same day. In the same country at war.',
    upvotes: 518,
    downvotes: 24,
    comments: 89,
  },
  {
    id: 3,
    number: "003",
    source: "Fox News",
    source_color: "#003366",
    category: "Weird",
    headline:
      '"Tiger Woods Arrested Again: Bloodshot Eyes, Slurred Speech in Shocking New Mugshot"',
    date: "March 27, 2026",
    read_time: "3 min read",
    fact_tags: [
      "2nd DUI arrest",
      "Breathalyzer: 0.00",
      "Refused urine test",
      "Dating Vanessa Trump",
      "Owner: Murdoch family",
    ],
    decoded:
      "Fox covers the mugshot and bloodshot eyes in forensic detail. They mention the 2017 DUI, the car crashes, the fall from grace. What they bury \u2014 paragraph 11 of 14 \u2014 is that Woods is currently dating Vanessa Trump, the ex-wife of Donald Trump Jr.\n\nImagine if this was Hunter Biden's girlfriend getting a DUI. It would be the headline, not paragraph 11.\n\nFox isn't hiding the information \u2014 they're just making sure you see the mugshot first and the Trump connection last. The order of facts IS the editorial decision.",
    pull_quote:
      "Fox isn't hiding the information \u2014 they're just making sure you see the mugshot first and the Trump connection last.",
    ap_comparison:
      "AP reported the arrest with the Vanessa Trump relationship in paragraph 3. Fox buried it in paragraph 11. Reuters mentioned it in paragraph 2. The fact existed in all coverage \u2014 the placement reveals the bias.",
    upvotes: 287,
    downvotes: 31,
    comments: 63,
  },
];

export const mediaGuideData = [
  {
    name: "Fox News",
    country: "USA",
    bias: "Right",
    owner: "Murdoch family (Fox Corporation)",
    color: "#003366",
    tier: 1,
    description:
      "Founded by Rupert Murdoch in 1996. The most-watched cable news network in America. Consistently frames stories to favor Republican and conservative positions.",
    why_critique:
      "Murdoch-owned, Trump megaphone. Frames right-wing talking points as neutral reporting.",
  },
  {
    name: "BBC News",
    country: "UK",
    bias: "State-funded",
    owner: "UK Government (License fee)",
    color: "#BB1919",
    tier: 1,
    description:
      "The world's oldest national broadcaster, funded by a mandatory TV license fee. Often seen as the gold standard of neutral journalism, but consistently frames global events through a UK-centric worldview.",
    why_critique:
      "UK-centric worldview disguised as neutrality. State-funded structure creates inherent conflicts.",
  },
  {
    name: "CNN",
    country: "USA",
    bias: "Left-center",
    owner: "Warner Bros. Discovery",
    color: "#CC0000",
    tier: 1,
    description:
      "Founded by Ted Turner in 1980. America's first 24-hour news channel. Positions itself as the middle ground but consistently applies a US Democrat-leaning lens to global stories.",
    why_critique:
      "US Democrat lens presented as global perspective. Treats American political framework as universal.",
  },
  {
    name: "Al Jazeera",
    country: "Qatar",
    bias: "State-funded",
    owner: "Government of Qatar",
    color: "#D4A843",
    tier: 1,
    description:
      "Launched in 1996, funded by the Qatari government. Provides excellent coverage of stories Western media ignores \u2014 but goes silent on anything that embarrasses Qatar.",
    why_critique:
      "Qatar foreign policy voice. Excellent on Palestine, silent on Qatar's own issues.",
  },
  {
    name: "Daily Mail",
    country: "UK",
    bias: "Right-populist",
    owner: "DMGT (Rothermere family)",
    color: "#1A1A6C",
    tier: 2,
    description:
      "Britain's highest-circulation newspaper. Masters of sensationalism, fear-based headlines, and celebrity gossip disguised as news.",
    why_critique: "Sensationalism as business model. Fear sells, outrage converts.",
  },
  {
    name: "New York Times",
    country: "USA",
    bias: "Liberal",
    owner: "Sulzberger family (NYT Co.)",
    color: "#1A1A1A",
    tier: 2,
    description:
      "America's 'paper of record.' Sets the agenda for liberal America. Excellent investigative journalism, but frames stories through an elite East Coast lens.",
    why_critique:
      "Liberal elite framing. Treats its worldview as the only educated perspective.",
  },
  {
    name: "Washington Post",
    country: "USA",
    bias: "Left-center",
    owner: "Jeff Bezos",
    color: "#2D2D2D",
    tier: 2,
    description:
      "Owned by Jeff Bezos since 2013. Strong investigative tradition (Watergate). The Bezos ownership creates obvious conflicts when covering Amazon, tech regulation, or labor issues.",
    why_critique:
      "Bezos ownership conflict. 'Democracy Dies in Darkness' \u2014 unless it's Amazon's labor practices.",
  },
  {
    name: "RT (Russia Today)",
    country: "Russia",
    bias: "State propaganda",
    owner: "Russian Government",
    color: "#5A8F29",
    tier: 3,
    description:
      "Kremlin-funded English-language outlet. Exists to push Russian foreign policy narratives to Western audiences. Mixes legitimate criticism of Western hypocrisy with outright disinformation.",
    why_critique:
      "Kremlin propaganda arm. Uses real Western failures to smuggle in Russian narratives.",
  },
];

export default analyses;
